module.exports = {
  pre_url: 'https://www.suonida.com:8899/api/',
  product_image_url: 'https://www.suonida.com:8899/product/',
  upload_file_url: 'https://www.suonida.com:8899/upload/'
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 1